export default __webpack_public_path__ + "static/media/done.23530ed8.svg";